import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ShopifyRedirect = ({ shopifyUrl, onCancel }) => {
  const [countdown, setCountdown] = useState(5);
  const navigate = useNavigate();

  useEffect(() => {
    if (!shopifyUrl) {
      navigate('/dashboard');
      return;
    }

    // Démarrer le compte à rebours
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          // Rediriger vers Shopify
          window.location.href = shopifyUrl;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [shopifyUrl, navigate]);

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4">
      <div className="max-w-md w-full bg-white shadow-md rounded-lg p-6">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-4">
          Connexion à Shopify
        </h2>
        
        <div className="text-center mb-6">
          <p className="text-gray-600 mb-2">
            Vous allez être redirigé vers Shopify pour autoriser l'application.
          </p>
          <p className="text-gray-600">
            Redirection dans <span className="font-bold text-indigo-600">{countdown}</span> secondes...
          </p>
        </div>
        
        <div className="flex flex-col space-y-4">
          <button
            onClick={() => window.location.href = shopifyUrl}
            className="w-full py-2 px-4 bg-indigo-600 hover:bg-indigo-700 text-white font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Connecter maintenant
          </button>
          
          <button
            onClick={handleCancel}
            className="w-full py-2 px-4 bg-white hover:bg-gray-50 text-gray-700 font-medium rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Connecter plus tard
          </button>
        </div>
        
        <div className="mt-6 text-sm text-gray-500">
          <p>
            Vous pourrez toujours connecter votre boutique Shopify ultérieurement depuis votre tableau de bord.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShopifyRedirect;
